import {
  Button,
  Grid,
  Stack,
  Typography,
  IconButton,
  DialogTitle,
  Box,
} from "@mui/material";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import QueueIcon from "@mui/icons-material/Queue";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { AppSettings } from "../../AppSettings";
import AppHelper from "../../Helper/AppHelper";
import Loader from "../Loader";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { Message } from "../../Interface/Message";
import AlertBox from "../CommonComponent/AlertBox";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import BorderColorIcon from "@mui/icons-material/BorderColor";

function FourKitesRuleList() {
  const [openLoader, setOpenloader] = React.useState(false);

  const [pageSize, setPageSize] = React.useState<number>(10);
  const navigate = useNavigate();
  const [FourKitesRule, setFourKitesRuleList] = React.useState<any>([]);

  const [selectionModel, setSelectionModel] = React.useState("");
  const [open, setOpen] = React.useState(false);

  function handleClose() {
    setOpen(false);
  }

  function handleAgree() {
    setOpen(false);
    deleteItems();
  }

  const pageHeader = {
    padding: 1,
    minWidth: 600,
    m: 1,
  };

  const [alertBoxmsg, setAlertBoxmsg] = React.useState<Message>({
    Type: "",
    Text: "",
  });

  const columns: GridColDef[] = [
    {
      field: "action",
      headerName: "Action",
      width: 150,
      sortable: false,
      disableExport: false,
      filterable: false,
      disableReorder: false,
      editable: false,

      renderCell: (params: { row: { [x: string]: string } }) => {
        const onClick = () => {
          navigate("/AddFourKitesRule?id=" + params.row["id"]);
          return;
        };
        const onDelete = () => {
          setOpen(true);
          var arr = new Array();
          var x = params.row["id"];
          var id: number = +x;
          arr.push(id);
          let selectedIds = JSON.stringify(arr);
          setSelectionModel(selectedIds);
          return;
        };
        return (
          <Stack direction="row" spacing={1}>
            {
              <IconButton color="primary" title="Edit" size="small">
                <BorderColorIcon onClick={onClick} />
              </IconButton>
            }
            {
              <IconButton color="primary" title="Delete" size="small">
                <DeleteIcon onClick={onDelete} />
              </IconButton>
            }
          </Stack>
        );
      },
    },
    { field: "name", headerName: "Name", width: 150 },
    { field: "description", headerName: "Description", width: 250 },
    { field: "isActive", headerName: "IsActive", width: 90 },
    { field: "createdBy", headerName: "Created By", width: 150 },
    { field: "displayCreatedDate", headerName: "Created Date", width: 150 },
    { field: "updatedBy", headerName: "UpdatedBy", width: 150 },
    { field: "displayUpdatedDateTime", headerName: "Updated Date", width: 150 },
  ];

  const useEffectCount = React.useRef(true);
  React.useEffect(() => {
    //AppHelper.isSuperAdminUser();
    if (useEffectCount.current) {
      let query = AppHelper.getQueryValue().get("msg");

      if (query != undefined || query != "" || query != null) {
        let msg: Message = { Text: "", Type: "" };
        if (query == "Create_Successful") {
          msg = { Text: "Rule Created Successfully.", Type: "Success" };
        }
        if (query == "Update_Successful") {
          msg = { Text: "Rule Updated Successfully.", Type: "Success" };
        }
        if (query == "Delete_Successful") {
          msg = { Text: "Rule Deleted Successfully.", Type: "Success" };
        }
        setAlertBoxmsg(msg);
      }

      useEffectCount.current = false;

      getFourKiteRules();
    }
  }, []);


  function getFourKiteRules() {
    setOpenloader(true);
    let apiUrl = AppSettings.API_URL + "Fourkites/GetAllFourKitesRule";
    fetch(apiUrl, AppHelper.requestOptions("POST"))
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          if (response.status == 401) navigate("/SessionExpired");
          else
            throw new Error(
              `API Error, This is an HTTP error: The status is ${response.status}`
            );
        }
        return response.json();
      })
      .then((data) => {
        setFourKitesRuleList(data);
      })
      .catch((err) => {
        if (err.message === "Failed to fetch") {
          navigate("/SessionExpired");
        } else {
          console.log(err.message);
        }
      })
      .finally(() => {
        setOpenloader(false);
      });
  }

  function handleImportFourKitesRule() {
    navigate("/ImportFourKitesRule");
  }

  function deleteItems() {
    setOpenloader(true);
    let msg: Message = { Text: "", Type: "" };

    if (
      selectionModel == "" ||
      selectionModel == undefined ||
      selectionModel == null
    ) {
      let msg: Message = {
        Text: "Please select an item in the list.",
        Type: "Error",
      };
      setAlertBoxmsg(msg);
      setOpenloader(false);
      return;
    }

    let apiUrl = AppSettings.API_URL + "Fourkites/DeleteRule";
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AppHelper.getUser().token,
      },
      body: selectionModel,
    };

    fetch(apiUrl, requestOptions)
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          if (response.status == 401) navigate("/SessionExpired");
          else
            throw new Error(
              `API Error, This is an HTTP error: The status is ${response.status}`
            );
        }
        return response.json();
      })
      .then(
        (data) => {
          if (data) {
            if (data.successes.length > 0) {
              window.location.href = "/Fourkites?msg=Delete_Successful";
            } else {
              msg = { Text: data.errors[0], Type: "Error" };
              setAlertBoxmsg(msg);
            }
          }

          setOpenloader(false);
        },
        (error) => {
          setOpenloader(false);
          let msg: Message = {
            Text: "Something went wrong please try again.",
            Type: "Error",
          };
          setAlertBoxmsg(msg);
          console.log("API Error: " + apiUrl + " " + error);
        }
      )
      .catch((err) => {
        if (err.message === "Failed to fetch") {
          navigate("/SessionExpired");
        } else {
          //API Error.
          let msgError: Message = {
            Text: err.message,
            Type: "Error",
          };
          setAlertBoxmsg(msgError);
        }
      })
      .finally(() => {
        setOpenloader(false);
      });
  }

  function handleCreate() {
    navigate("/AddFourKitesRule");
  }

  return (
    <div className="page-container">
      <>
        {" "}
        <Dialog
          open={open}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "95%",
                maxWidth: "480px", // Set your width here
              },
            },
          }}
        >
          <DialogTitle>{"Are you Sure?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Do you really want to delete? This process cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Disagree</Button>
            <Button onClick={handleAgree}>Agree</Button>
          </DialogActions>
        </Dialog>
      </>
      <div className="data-list">
        <Loader value={openLoader}></Loader>
        {alertBoxmsg.Text !== "" && (
          <div className="msg-div">
            <AlertBox value={alertBoxmsg}></AlertBox>{" "}
          </div>
        )}
        <Grid container spacing={2} sx={pageHeader}>
          <Grid item sm={8} md={10} lg={9}>
            <Typography
              component="h1"
              variant="h6"
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              <ManageAccountsIcon
                sx={{ fontSize: 30, marginRight: 1 }}
              ></ManageAccountsIcon>{" "}
              <b>FourKites Rules</b>
            </Typography>
          </Grid>
          <Grid item sm={4} md={2} lg={3}>
          <Box display="flex" justifyContent="flex-end" gap={1} paddingRight={3}>
            <Button
              variant="contained"
              onClick={handleCreate}
              size="medium"
              startIcon={<QueueIcon />}
            >
              Add Rules
            </Button>{" "}
            <Button
              variant="outlined"
              onClick={handleImportFourKitesRule}
              size="medium"
              startIcon={<ImportExportIcon />}
            >
              Import
            </Button>
            </Box>
          </Grid>
        </Grid>
        <div style={{ height: 600, width: "100%" }}>
          {
            <DataGrid
              rows={FourKitesRule}
              columns={columns}
              sx={{
                boxShadow: 3,
                "& .MuiDataGrid-cell:hover": {
                  color: "primary.main",
                },
              }}
              slots={{ toolbar: GridToolbar }}
              checkboxSelection
              disableRowSelectionOnClick
              onRowSelectionModelChange={(ids: any) => {
                let selectedIds = JSON.stringify(ids);

                setSelectionModel(selectedIds);
              }}
            />
          }
        </div>
      </div>

      <div className="blank-div"></div>
    </div>
  );
}

export default FourKitesRuleList;
